import { toast } from "react-toastify";
import { ProjectMarginTarget } from "models/project-margin-target";

// API only: the page dispatches the slice actions after these resolve.
const BASE = `${process.env.REACT_APP_API_URL}/project-margin-targets`;

export interface ProjectMarginTargetValues {
    fiscalYear: number
    minimumMargin: number
    warningMargin: number
    idealMargin: number
}

const send = async (url: string, method: string, body?: unknown) => {
    const res = await fetch(url, {
        credentials: 'include',
        method,
        headers: body ? { 'Content-Type': 'application/json' } : undefined,
        body: body ? JSON.stringify(body) : undefined,
    });
    if (!res.ok) {
        const errBody = await res.json().catch(() => null);
        throw new Error(errBody?.message ?? "Request failed");
    }
    return res.json();
}

export const getProjectMarginTargets = async (): Promise<ProjectMarginTarget[] | null> => {
    try {
        return (await send(BASE, 'GET')).data as ProjectMarginTarget[];
    } catch (err: any) {
        toast.error(err.message ?? "Error getting margin targets");
        return null;
    }
}

export const submitCreateProjectMarginTarget = async (vals: ProjectMarginTargetValues): Promise<ProjectMarginTarget | null> => {
    try {
        const data = (await send(BASE, 'POST', vals)).data as ProjectMarginTarget;
        toast.success("Margin target created.");
        return data;
    } catch (err: any) {
        toast.error(err.message ?? "Error creating margin target");
        return null;
    }
}

export const submitEditProjectMarginTarget = async (id: string, vals: ProjectMarginTargetValues): Promise<ProjectMarginTarget | null> => {
    try {
        const data = (await send(`${BASE}/${id}`, 'PATCH', vals)).data as ProjectMarginTarget;
        toast.success("Margin target updated.");
        return data;
    } catch (err: any) {
        toast.error(err.message ?? "Error updating margin target");
        return null;
    }
}

export const deleteProjectMarginTargetRequest = async (id: string): Promise<boolean> => {
    try {
        await send(`${BASE}/${id}`, 'DELETE');
        toast.success("Margin target deleted.");
        return true;
    } catch (err: any) {
        toast.error(err.message ?? "Error deleting margin target");
        return false;
    }
}
